import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography, Select, InputLabel, FormControl, MenuItem, FormGroup, FormControlLabel, Checkbox, RadioGroup, Radio, FormLabel } from "@material-ui/core";
import * as Yup from "yup";
import Image from 'material-ui-image';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    imgDiv: {
        margin: '0 auto',
        maxWidth: 600,
        maxHeight: 600
    },
    formControl: {
        width: "100%"
    }
});

const FilePatternForm = props => {
    const { classes, formSettings, logos, initialValues, loading, handleSubmit, translations, activeCustomerAddress } = props;
    
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    
                    let logoImage = logos.filter(value => { return value.value === values.LogoID });
                   
                    if (!values.Address) {
                        values.Address = activeCustomerAddress;
                    }
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations['name'] || 'Name'}
                                label={translations['name'] || 'Name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="CompanyName"
                                value={values.CompanyName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.CompanyName && touched.CompanyName)}
                                placeholder={translations['company_name'] || 'Company name'}
                                label={translations['company_name'] || 'Company name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Address"
                                value={values.Address}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Address && touched.Address)}
                                placeholder={translations['address'] || 'Address'}
                                label={translations['address'] || 'Address'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"IncludePerformedDiagnoseCasesOnly"}
                                            checked={values.IncludePerformedDiagnoseCasesOnly}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={`${translations['include_only_performed_diagnose_cases'] || 'Include only performed diagnose cases in reports'}`}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"AddPhotosToErasureReports"}
                                            checked={values.AddPhotosToErasureReports}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={`${translations['add_photos_to_erasure_reports'] || 'Add photos to erasure reports'}`}
                                />
                                {
                                    values.AddPhotosToErasureReports ?
                                        <FormGroup row>
                                            <FormControl>
                                                <FormLabel>{`${translations['erasure_report_photos_layout'] || 'Erasure report photos layout'}`}</FormLabel>
                                                <RadioGroup
                                                    row
                                                    name={'ErasureReportPhotosLayout'}
                                                    value={values.ErasureReportPhotosLayout}
                                                    onChange={handleChange}
                                                >
                                                    <FormControlLabel
                                                        value="2x2"
                                                        control={<Radio />}
                                                        label="2x2"
                                                    />
                                                    <FormControlLabel
                                                        value="3x3"
                                                        control={<Radio />}
                                                        label="3x3"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </FormGroup> : null
                                }
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"AddPhotosToDiagnoseReports"}
                                            checked={values.AddPhotosToDiagnoseReports}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={`${translations['add_photos_to_diagnose_reports'] || 'Add photos to diagnose reports'}`}
                                />
                                {
                                    values.AddPhotosToDiagnoseReports ?
                                        <FormGroup row>
                                            <FormControl>
                                                <FormLabel>{`${translations['diagnose_report_photos_layout'] || 'Diagnose report photos layout'}`}</FormLabel>
                                                <RadioGroup
                                                    row
                                                    name={'DiagnoseReportPhotosLayout'}
                                                    value={values.DiagnoseReportPhotosLayout}
                                                    onChange={handleChange}
                                                >
                                                    <FormControlLabel
                                                        value="2x2"
                                                        control={<Radio />}
                                                        label="2x2"
                                                    />
                                                    <FormControlLabel
                                                        value="3x3"
                                                        control={<Radio />}
                                                        label="3x3"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </FormGroup> : null
                                }
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"AddPhotosToVerificationReports"}
                                            checked={values.AddPhotosToVerificationReports}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={`${translations['add_photos_to_verification_reports'] || 'Add photos to verification reports'}`}
                                />
                                {
                                    values.AddPhotosToVerificationReports ?
                                        <FormGroup row>
                                            <FormControl>
                                                <FormLabel>{`${translations['verification_report_photos_layout'] || 'Verification report photos layout'}`}</FormLabel>
                                                <RadioGroup
                                                    row
                                                    name={'VerificationReportPhotosLayout'}
                                                    value={values.VerificationReportPhotosLayout}
                                                    onChange={handleChange}
                                                >
                                                    <FormControlLabel
                                                        value="2x2"
                                                        control={<Radio />}
                                                        label="2x2"
                                                    />
                                                    <FormControlLabel
                                                        value="3x3"
                                                        control={<Radio />}
                                                        label="3x3"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </FormGroup> : null
                                }
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"IncludeGradingInErasureReports"}
                                            checked={values.IncludeGradingInErasureReports}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={`${translations['include_grading_in_erasure_reports'] || 'Include grading info in erasure reports'}`}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"IncludeDiagnoseInErasureReports"}
                                            checked={values.IncludeDiagnoseInErasureReports}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={`${translations['include_diagnose_in_erasure_reports'] || 'Include diagnose info in erasure reports'}`}
                                />
                            </FormGroup>
                            {logoImage.length > 0 || logos.length > 0 ?
                                <div className={classes.imgDiv}>
                                    <Image
                                        src={logoImage.length > 0 ? logoImage[0].imageLocation : logos.length > 0 ? logos[0].imageLocation : ''}
                                        aspectRatio={(16 / 9)}
                                        disableSpinner
                                    />
                                </div>
                                : null
                            }
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['logo_text'] || "Please select logo for report"}</InputLabel>
                                <Select
                                    name="LogoID"
                                    label={translations["report_information"] || "Report information"}
                                    margin={"dense"}
                                    value={logos.length > 0 ? values.LogoID : ''}
                                    onChange={handleChange}
                                >
                                    {(logos ? [...logos] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >
                                        {formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(FilePatternForm);
